
import {createSlice} from "@reduxjs/toolkit";


export const productSearchSlice = createSlice({
    name: 'productSearchSlc',
    initialState: {value: {
            searchData: null,
            eidr: null,
            episodeName: null,
            externalId: null,
            financialCode: null,
            genre: null,
            initMkt: null,
            m4mktGroup: null,
            producer: null,
            productionType: null,
            name: null,
            photoStartDateFrom: null,
            photoStartDateTo: null,
            seasonExternalId: null,
            seriesExternalId: null,
            seasonName: null,
            seriesName: null,
            seasonNumberFrom: null,
            seasonNumberTo: null,
            participations: null,
            residuals: null,
            royalties: null,
            coveredProduct: null

        }},
    reducers:

{
        changeProductSearch: (state, action) => {
                state.value = {
                        ...state.value,  // Keep existing fields
                        ...action.payload // Merge new values
                };
        }
}
});

export const { changeProductSearch } = productSearchSlice.actions;

export default  productSearchSlice.reducer ;

